import type { infra } from '@photo-vault/shared';
import {
  cognitoSignIn,
  cognitoSignOut,
  cognitoSignUp,
  type CognitoSession,
} from '../../lib/cognito.js';
import {
  completeOidcLogin,
  getOidcUser,
  oidcSignOut,
  startOidcLogin,
  type OidcLoginResult,
  type SocialProvider,
} from '../../lib/oidc.js';

// Thin facade over the existing Cognito + OIDC helpers. Behavior is
// unchanged — the goal is to route every auth call through useInfra().auth so
// we can later swap in a non-Cognito driver without touching pages.
export const awsAuthDriver: infra.AuthDriver = {
  async signUp(email, password) {
    return cognitoSignUp(email, password);
  },
  async signIn(email, password) {
    const session: CognitoSession = await cognitoSignIn(email, password);
    return session;
  },
  async startFederatedLogin(provider) {
    return startOidcLogin(provider as SocialProvider | undefined);
  },
  async completeFederatedLogin() {
    const result: OidcLoginResult = await completeOidcLogin();
    return result;
  },
  async getFederatedUser() {
    return getOidcUser();
  },
  async signOut(provider) {
    if (provider === 'federated') {
      await oidcSignOut();
      return;
    }
    cognitoSignOut();
  },
};
